// extracted by mini-css-extract-plugin
module.exports = {"spaceSelectorButton":"styles_spaceSelectorButton__SxoIM"};